import { rootRoute } from './root'
import { generalRoute } from './general'
import { authenticationRoute } from './authentication'
import { apisRoute } from './apis'
import { experienceRoute } from './experience'
import { appearanceRoute } from './appearance'
import { securityRoute } from './security'

export const applicationRoute = rootRoute.addChildren([
    generalRoute,
    authenticationRoute,
    apisRoute,
    experienceRoute,
    appearanceRoute,
    securityRoute,
])
